export const isProd =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === 'production';

export const isStaging =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === 'development';

export const isLocal = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === 'local';

export const isE2eTest =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === 'testing';

export const FRONTEND_DOMAIN = process.env.NEXT_PUBLIC_FRONTEND_URL ?? '';
